import computed from './computed'
import methods from './methods'

export default {
  computed,
  methods
}



// WEBPACK FOOTER //
// ./src/app/patient/config/resources/index.js